import Button from '@sdk/components/ui/buttons/Button';
import useAuth from '@sdk/authentication/useAuth';
import useModalState from '@sdk/components/ui/modal/useModalState';
import gettext from '@sdk/lang/gettext';
import { Feature } from '@sdk/common/features';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';

import CreateTimesheetModal from '@web/timesheets/CreateTimesheetModal/CreateTimesheetModal';

type Props = {
  onCreateTimesheet: VoidFunction;
};
const CreateTimesheet = ({ onCreateTimesheet }: Props) => {
  const { currentUser, isOrgFeatureEnabled } = useAuth();
  const { clockInEnabled } = currentUser.orgSettings;
  const { isVisible, open, close } = useModalState();

  const canDisplayCreateTimesheetButton =
    currentUser.isManager && isOrgFeatureEnabled(Feature.clockIn) && clockInEnabled;

  if (!canDisplayCreateTimesheetButton) {
    return null;
  }

  return (
    <>
      <Button buttonType={ButtonType.primary} onClick={open}>
        {gettext('Create timesheet')}
      </Button>
      <CreateTimesheetModal
        close={close}
        isVisible={isVisible}
        onCreateTimesheet={onCreateTimesheet}
      />
    </>
  );
};

export default CreateTimesheet;
